import React from 'react';
import { showLoader, hideLoader } from './DarkLoader';

function FullScreenDarkLoader() {
  React.useLayoutEffect(() => {
    showLoader();
    return () => {
      hideLoader();
    };
  }, []);

  return null;
}

export default FullScreenDarkLoader;
